import React, { useState } from 'react'
import {Mail, Sparkles} from 'lucide-react'

export function Newsletter() {
  const [email, setEmail] = useState('')
  const [subscribed, setSubscribed] = useState(false)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (email) {
      // Simulate subscription
      setSubscribed(true)
      setEmail('')
      setTimeout(() => setSubscribed(false), 5000)
    }
  }

  return (
    <section className="bg-gradient-to-r from-pink-500 via-orange-500 to-teal-500 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="flex justify-center mb-4">
          <Sparkles className="w-12 h-12 text-white animate-pulse" />
        </div>
        <h3 className="text-3xl sm:text-4xl font-bold text-white mb-4">
          Never Miss a Magical Moment
        </h3>
        <p className="text-xl text-white/90 mb-8">
          Subscribe to get the latest reviews, episode guides, and exclusive cartoon content delivered to your inbox!
        </p>
        
        {subscribed ? (
          <div className="bg-white/20 backdrop-blur-sm border-2 border-white rounded-full px-8 py-4 inline-flex items-center gap-2">
            <Mail className="w-6 h-6 text-white" />
            <span className="text-white font-semibold text-lg">
              🎉 Thanks for subscribing! Check your email for confirmation.
            </span>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="max-w-xl mx-auto">
            <div className="flex flex-col sm:flex-row gap-4">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email address"
                required
                className="flex-1 px-6 py-4 rounded-full text-gray-800 text-lg focus:outline-none focus:ring-4 focus:ring-white/50 shadow-lg"
              />
              <button
                type="submit"
                className="bg-white text-pink-500 px-8 py-4 rounded-full font-bold text-lg hover:bg-gray-100 transform hover:scale-105 transition-all shadow-lg whitespace-nowrap"
              >
                Subscribe Now
              </button>
            </div>
            <p className="text-white/80 text-sm mt-4">
              We respect your privacy. Unsubscribe anytime.
            </p>
          </form>
        )}
      </div>
    </section>
  )
}
